import { useDelayedDocument } from "hooks/firestore/core/useDelayedDocument"
import { getShopRef } from "hooks/firestore/getRefs"
import { useShopId } from "hooks/localstate/context/useShopId"
import Shop from "types/firestore/shop"

export function useDelayedShop() {
  const shopId = useShopId()
  const ref = getShopRef(shopId)
  const { delayedDocument: shop, updateDocument: updateShop, commit } = useDelayedDocument<Shop>(ref)
  return { shop, updateShop, commit }
}
